import EndpointTemplate from '../constants/EndpointTemplate';

const Endpoint = {
  getCategories: (productType: string) =>
    EndpointTemplate.Categories.replace(':productType', productType),
  getCategory: (productType: string, categoryId: string) =>
    EndpointTemplate.Category.replace(':productType', productType).replace(
      ':categoryId',
      categoryId
    ),
  getCategoriesByIds: () => EndpointTemplate.CategoriesByIds,

  getThemes: (productType: string) =>
    EndpointTemplate.Themes.replace(':productType', productType),
  getTheme: (productType: string, themeId: string) =>
    EndpointTemplate.Theme.replace(':productType', productType).replace(
      ':themeId',
      themeId
    ),

  getProviders: (productType: string) =>
    EndpointTemplate.Providers.replace(':productType', productType),
  getProvider: (productType: string, providerId: string) =>
    EndpointTemplate.Provider.replace(':productType', productType).replace(
      ':providerId',
      providerId
    ),
  getProvidersByIds: () => EndpointTemplate.ProvidersByIds,

  // Games
  getGames: (productType: string) =>
    EndpointTemplate.Games.replace(':productType', productType),
  getGameInfo: (productType: string, gameId: string) =>
    EndpointTemplate.GameInfo.replace(':productType', productType).replace(
      ':gameId',
      gameId
    ),
  getDemoGame: (productType: string, gameId: string) =>
    EndpointTemplate.DemoGame.replace(':productType', productType).replace(
      ':gameId',
      gameId
    ),
  getRealGame: (productType: string, gameId: string) =>
    EndpointTemplate.RealGame.replace(':productType', productType).replace(
      ':gameId',
      gameId
    ),
  getGamesByIds: (productType: string) =>
    EndpointTemplate.GamesByIds.replace(':productType', productType),

  getRandomGame: (productType: string) =>
    EndpointTemplate.GameRandom.replace(':productType', productType),

  getFavourites: (productType: string) =>
    EndpointTemplate.Favourites.replace(':productType', productType),
  getToggleFavouriteGame: (productType: string, gameId: string) =>
    EndpointTemplate.ToggleFavouriteGame.replace(
      ':productType',
      productType
    ).replace(':gameId', gameId),
  getFavouritesCommon: () => EndpointTemplate.FavouritesCommon,

  getJackpots: (productType: string) =>
    EndpointTemplate.Jackpots.replace(':productType', productType),
  getHallOfFame: (productType: string) =>
    EndpointTemplate.HallOfFame.replace(':productType', productType),

  getRecents: (productType: string) =>
    EndpointTemplate.Recents.replace(':productType', productType),
  addRecents: (productType: string) =>
    EndpointTemplate.RecentsBulk.replace(':productType', productType),

  // Bonus system
  getBonuses: (productType: string) =>
    EndpointTemplate.Bonuses.replace(':productType', productType),
  // deprecated
  getBonusGames: (productType: string) =>
    EndpointTemplate.BonusGames.replace(':productType', productType),
  //
  getBonusCampaign: (productType: string, campaignId: string) =>
    EndpointTemplate.BonusCampaign.replace(':productType', productType).replace(
      ':campaignId',
      campaignId
    ),

  getBonusHistory: (productType: string) =>
    EndpointTemplate.BonusHistory.replace(':productType', productType),
  getBonusCollectingGames: (productType: string, campaignId: string) =>
    EndpointTemplate.BonusCollectingGames.replace(
      ':productType',
      productType
    ).replace(':campaignId', campaignId),

  getJoinCampaign: (productType: string, campaignId: string) =>
    EndpointTemplate.JoinCampaign.replace(':productType', productType).replace(
      ':campaignId',
      campaignId
    ),
  getUnjoinBonus: (productType: string, bonusId: string) =>
    EndpointTemplate.UnjoinBonus.replace(':productType', productType).replace(
      ':bonusId',
      bonusId
    ),
  getRejectBonus: (productType: string, bonusId: string, campaignId: string) =>
    EndpointTemplate.RejectBonus.replace(':productType', productType)
      .replace(':bonusId', bonusId)
      .replace(':campaignId', campaignId),

  getTakeBonus: (productType: string, bonusId: string, campaignId: string) =>
    EndpointTemplate.TakeBonus.replace(':productType', productType)
      .replace(':bonusId', bonusId)
      .replace(':campaignId', campaignId),
};

export default Endpoint;
